import { Api } from '../../types/api'
import User = Api.User
import React, { useEffect, useReducer, useState } from 'react'
import { USER_ACTION_CHANGE, UserActionTypes, userReducer } from './userReducer'
import { useSession } from 'next-auth/react'
import { Session } from 'next-auth'
import { fetcher } from '../api/io'
import { useRouter } from 'next/router'
import { routes } from '../utils/routes'
import { isAllowed } from '../utils/Helpers'
import FourOhThree from '../pages/403'
import Context = Api.Context
import { APPLICATION_ACTION_CHANGE, ApplicationActionTypes, applicationReducer } from './applicationReducer'
import { usePiwikPro } from '@piwikpro/next-piwik-pro'

export type ActionTypes = UserActionTypes | ApplicationActionTypes

export interface UserState {
    user: User | null
}

export interface ApplicationState {
    applicationContext: Context | null
}

export interface AppState {
    userState: UserState
    applicationState: ApplicationState
}
const defaultState: AppState = {
    userState: {
        user: null,
    },
    applicationState: {
        applicationContext: null,
    },
}

export interface AppContext {
    state: AppState
    dispatch: React.Dispatch<ActionTypes>
}

const appContext = React.createContext<AppContext>({
    state: defaultState,
    dispatch: () => null,
})

const mainReducer = (state: AppState, action: ActionTypes): AppState => ({
    // status: statusReducer(state.status, action as StatusActionTypes),
    userState: userReducer(state.userState, action as UserActionTypes),
    applicationState: applicationReducer(state.applicationState, action as ApplicationActionTypes),
})

interface AppProviderProps {
    user: User | null
    children: React.ReactNode
}

const AppProvider = (props: AppProviderProps) => {
    const { data: session, status } = useSession()
    const { CustomDimensions } = usePiwikPro()
    const router = useRouter()
    const [hasRoles, setHasRoles] = useState(false)

    useEffect(() => {
        console.log('applicationStateContext', state.applicationState.applicationContext)
        const fetchApplicationContext = async () => {
            const context = await fetcher<null, Context>({
                url: '/context',
            })

            console.log('fetchedContext', context)

            dispatch({
                type: APPLICATION_ACTION_CHANGE,
                applicationContext: context,
            })
        }

        if (!state.applicationState.applicationContext) void fetchApplicationContext()
    }, [])

    useEffect(() => {
        // console.log('PATHNAME:', router.pathname)

        const key = Object.keys(routes).find((key) => routes[key]?.path === router.pathname)
        setHasRoles(isAllowed(key ? routes[key].roles : [], props.user ? props.user.roles : [], 'some'))
    }, [router.pathname, props.user])

    useEffect(() => {
        const fetchUser = async (session: Session) => {
            const user = await fetcher<null, User>({
                url: '/users/' + session.user.id,
                accessToken: session.user.accessToken,
            })
            dispatch({
                type: USER_ACTION_CHANGE,
                user: user,
            })
            return user
        }

        if (status === 'authenticated' && props.user === null) {
            fetchUser(session).catch(console.error)
        }
        if (session) {
            CustomDimensions.setCustomDimensionValue(1, 'logged_in')
        }
    }, [status, session])

    const initialState = { ...defaultState, userState: { user: props.user } }

    const [state, dispatch] = useReducer(mainReducer, initialState)
    if (!hasRoles) return <FourOhThree />
    return <appContext.Provider value={{ state, dispatch }}>{props.children}</appContext.Provider>
}

export { AppProvider, appContext }
